import React, { useMemo } from 'react';
import { useIntl } from "react-intl";
import messages from "../../../../locale/jsonMessages";
import { useSelector } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { GoBackRightArrow } from '../../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import { getFormValues } from 'redux-form';
import { getCurrencySymbol } from '../../../../helpers/currencyConvertion';
import cs from '../../../../components/commonStyle.css';

const CarPricingAIForm = () => {
    const { formatMessage, locale } = useIntl();
    const aiPricingData = useSelector(state => state?.aiContents?.aiPricingData);
    const formValues = useSelector(state => getFormValues('ListPlaceStep1')(state)) || {};
    const nearbyLink = useMemo(() => `/s?&address=${formValues.city || ''}&chosen=1`, [formValues.city]);

    const currencySymbol = useMemo(() => {
        if (aiPricingData?.currency) {
            return getCurrencySymbol(aiPricingData.currency, locale);
        }
        return '';
    }, [aiPricingData?.currency, locale]);

    return (
        <div>
            <p className={cx(cs.commonSmallText16, cs.spaceBottom2)}>
                <span>{formatMessage(messages.marketPricingLabel)}</span>:&nbsp;
                {currencySymbol}{aiPricingData?.min_price} - {currencySymbol}{aiPricingData?.max_price}
            </p>
            <p className={cx(cs.commonSmallText16, cs.spaceBottom2)}>{formatMessage(messages.aiPricingContent)}</p>
            <a href={nearbyLink} target='_blank' rel="noopener noreferrer" className='goBackLink' >
                {formatMessage(messages.checkNearByCarsLabel)}
                <GoBackRightArrow />
            </a>
        </div>
    );
}

export default (withStyles(cs)(CarPricingAIForm));
